// extracted by mini-css-extract-plugin
module.exports = {"SectionA5":"SectionA5_SectionA5__p6_aD"};